import { agencyMode, agencyName } from 'app/services/env.service';
import { createDefaultTheme } from 'app/styles/createDefaultTheme';
import { createAgencyTheme } from 'app/styles/createAgencyTheme';

export const createMyTheme = () => {
  const isDefaultMode = !agencyMode || !agencyName;

  return isDefaultMode ? createDefaultTheme() : createAgencyTheme();
};
